import React from 'react';

import { IconBaseProps } from 'react-icons/lib/cjs';
import { Container, IconSection, TextSection } from './styles';

interface BannerProps {
  description?: string;
  title: string;
  icon?: React.ComponentType<IconBaseProps>;
  id?: string;
}

const Banner: React.FC<BannerProps> = ({
  description,
  title,
  icon: Icon,
  id,
  children,
}) => {
  return (
    <Container id={id}>
      <IconSection>
        <div
          style={{
            background: '#C4C4C4',
            width: 150,
            height: 150,
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {Icon && <Icon size={72} color="#FFFFFF" />}
        </div>
        <strong>{title}</strong>
      </IconSection>
      <TextSection>
        <p>{description}</p>
        {children}
      </TextSection>
    </Container>
  );
};

export default Banner;
